import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import languageSettingsService from "../../services/languageSettingsService";

// Queries
export const useGetLanguageSettings = (queryOptions = {}) => {
  return useQuery(["languageSettings"], languageSettingsService.index, queryOptions);
};

// Mutations
export const useUpdateLanguageSettings = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(languageSettingsService.update, {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["languageSettings"], data);
      mutationOptions.onSuccess && mutationOptions.onSuccess(data);
    },
  });
}; 